<template>
<div class="page vertical-align text-center"
     data-animsition-in="fade-in"
     data-animsition-out="fade-out">
    <div class="page-content vertical-align-middle animation-slide-top animation-duration-1">
        <div class="panel"
             v-if="displayForm">

             <div class="panel-bordered">
                <div class="panel-body">
                    <div class="brand">
                        <img class="brand-img"
                             src="/external/images/ecdltd-logo.png"
                             alt=""
                             width="250px">
                    </div>
                    <div class="form-text">
                        <p>
                            Please fill in the form below if you wish to sell or buy from us.
                        </p>
                    </div>
                </div>
             </div>

             <div class="panel-bordered">
                <div class="panel-heading">
                    <h3 class="panel-title">Personal</h3>
                </div>
                <div class="panel-body">
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <input type="text"
                               class="form-control"
                               name="first_name"
                               id="first_name"
                               v-model="form.first_name" />
                        <label class="floating-label">First Name*</label>
                        <div v-if="errors.first_name"
                             class="invalid-feedback">
                            {{ errors.first_name }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <input type="text"
                               class="form-control"
                               name="last_name"
                               v-model="form.last_name"
                               id="last_name" />
                        <label class="floating-label">Last Name*</label>
                        <div v-if="errors.last_name"
                             class="invalid-feedback">
                            {{ errors.last_name }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Job Title</label>
                        <treeselect :class="{'is-invalid': errors['job_title'] }"
                                    v-model="form.job_title"
                                    :options="jobTitles"
                                    placeholder="Select your job title..."
                                    :normalizer="normalizer"
                                    open-direction="below"></treeselect>
                        <div v-if="errors['job_title']"
                             class="invalid-feedback">
                            {{ errors['job_title'] }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <input type="email"
                               class="form-control"
                               name="email"
                               id="email"
                               v-model="form.email" />
                        <label class="floating-label">Email*</label>
                        <div v-if="errors.email"
                             class="invalid-feedback">
                            {{ errors.email }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <input type="text"
                               class="form-control"
                               name="office_number"
                               id="office_number"
                               v-model="form.office_number" />
                        <label class="floating-label">Landline Number</label>
                        <div v-if="errors.office_number"
                             class="invalid-feedback">
                            {{ errors.office_number }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <input type="text"
                               class="form-control"
                               name="mobile_number"
                               id="mobile_number"
                               v-model="form.mobile_number" />
                        <label class="floating-label">Mobile</label>
                        <div v-if="errors.mobile_number"
                             class="invalid-feedback">
                            {{ errors.mobile_number }}
                        </div>
                    </div>
                    <div class="form-group form-material checkbox-custom checkbox-default"
                         data-plugin="formMaterial">
                        <input :class="{'is-invalid': errors.whatsapp_me }"
                               v-model="form.whatsapp_me"
                               type="checkbox"
                               id="whatsapp_me"
                               name="whatsapp_me"
                               checked=""
                               autocomplete="off">
                        <label class="control-label-static">
                            Whatsapp me on this number
                        </label>
                        <div v-if="errors.whatsapp_me"
                             class="invalid-feedback">
                            {{ errors.whatsapp_me }}
                        </div>
                    </div>
                </div>
             </div>

             <div class="panel-bordered">
                <div class="panel-heading">
                    <h3 class="panel-title">Business</h3>
                </div>
                 <div class="panel-body">
                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.company_name">
                        <label class="floating-label">Company*</label>
                        <div v-if="errors.company_name" 
                            class="invalid-feedback">
                            {{ errors.company_name }}
                        </div>
                    </div>
                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.vat_number">
                        <label class="floating-label">VAT Number</label>
                        <div v-if="errors.vat_number" 
                            class="invalid-feedback">
                            {{ errors.vat_number }}
                        </div>
                    </div>
                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.company_registration_number">
                        <label class="floating-label">Company Registration Number</label>
                        <div v-if="errors.company_registration_number" 
                            class="invalid-feedback">
                            {{ errors.company_registration_number }}
                        </div>
                    </div>
                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.website">
                        <label class="floating-label">Website</label>
                        <div v-if="errors.website" 
                            class="invalid-feedback">
                            {{ errors.website }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Turnover*</label>
                        <treeselect :class="{'is-invalid': errors.turnover }"
                                    v-model="form.turnover"
                                    :options="turnovers"
                                    :normalizer="normalizer"
                                    :flat="true"
                                    placeholder="Select your business turnover..."
                                    open-direction="below"></treeselect>
                        <div v-if="errors.turnover"
                             class="invalid-feedback">
                            {{ errors.turnover }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Sector*</label>
                        <treeselect :class="{'is-invalid': errors.sector }"
                                    v-model="form.sector"
                                    :options="sectors"
                                    :normalizer="normalizer"
                                    :flat="true"
                                    placeholder="Select your business sector..."
                                    open-direction="below"></treeselect>
                        <div v-if="errors.sector"
                             class="invalid-feedback">
                            {{ errors.sector }}
                        </div>
                    </div> 
                 </div>
             </div>

             <div class="panel-bordered">
                <div class="panel-heading">
                    <h3 class="panel-title">Address</h3>
                </div>
                 <div class="panel-body">
                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.address.building_name">
                        <label class="floating-label">Building Name</label>
                        <div v-if="errors['address.building_name']" 
                            class="invalid-feedback">
                            {{ errors['address.building_name'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.address.building_number">
                        <label class="floating-label">Building Number</label>
                        <div v-if="errors['address.building_number']" 
                            class="invalid-feedback">
                            {{ errors['address.building_number'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.address.street">
                        <label class="floating-label">Street</label>
                        <div v-if="errors['address.street']" 
                            class="invalid-feedback">
                            {{ errors['address.street'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.address.postcode">
                        <label class="floating-label">Postcode / Zip</label>
                        <div v-if="errors['address.postcode']" 
                            class="invalid-feedback">
                            {{ errors['address.postcode'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.address.city">
                        <label class="floating-label">City</label>
                        <div v-if="errors['address.city']" 
                            class="invalid-feedback">
                            {{ errors['address.city'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.address.state">
                        <label class="floating-label">State</label>
                        <div v-if="errors['address.state']" 
                            class="invalid-feedback">
                            {{ errors['address.state'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Country</label>
                        <treeselect :class="{'is-invalid': errors['address.country'] }"
                                    v-model="form.address.country"
                                    :options="countries"
                                    placeholder="Select country..."
                                    :normalizer="normalizer"
                                    open-direction="below"></treeselect>
                        <div v-if="errors['address.country']"
                             class="invalid-feedback">
                            {{ errors['address.country'] }}
                        </div>
                    </div>
                 </div>
             </div>

             <div class="panel-bordered">
                 <div class="panel-heading">
                     <h4 class="panel-title">Preferred Communication Method</h4>
                 </div>

                 <div class="panel-body">
                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.whatsapp">
                        <label class="floating-label">Whatsapp</label>
                        <div v-if="errors.whatsapp" 
                            class="invalid-feedback">
                            {{ errors.whatsapp }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.wechat">
                        <label class="floating-label">WeChat</label>
                        <div v-if="errors.wechat" 
                            class="invalid-feedback">
                            {{ errors.wechat }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.skype">
                        <label class="floating-label">Skype</label>
                        <div v-if="errors.skype" 
                            class="invalid-feedback">
                            {{ errors.skype }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.viber">
                        <label class="floating-label">Viber</label>
                        <div v-if="errors.viber" 
                            class="invalid-feedback">
                            {{ errors.viber }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <input type="text" class="form-control" v-model="form.linkedin">
                        <label class="floating-label">Linkedin</label>
                        <div v-if="errors.linkedin" 
                            class="invalid-feedback">
                            {{ errors.linkedin }}
                        </div>
                    </div>

                    <div class="form-inline">
                        <div class="form-group form-material floating" 
                            data-plugin="formMaterial">
                            <input type="text" class="form-control inline-input" v-model="form.other_name">
                            <label class="floating-label">Other Name</label>
                        </div>
                        <div class="form-group form-material" 
                            data-plugin="formMaterial">
                            <input type="text" class="form-control inline-input" v-model="form.other_details">
                            <label class="floating-label">Other Contact Details</label>
                        </div>

                        <div v-if="errors.other_name || errors.other_details" 
                                class="inline invalid-feedback mt-1">
                                {{ errors.other_name || errors.other_details }}
                        </div>
                    </div>
                 </div>
             </div>

             <div class="panel-bordered">
                 <div class="panel-heading">
                     <h3 class="panel-title">Preferences</h3>
                 </div>

                 <div class="panel-body">
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Product Categories* (Max: 3)</label>
                        <treeselect :class="{'is-invalid': errors.product_categories }"
                                    v-model="form.product_categories"
                                    :options="productCategoriesForSelect"
                                    :multiple="true"
                                    :flat="true"
                                    placeholder="Select upto 3 product categories..."
                                    open-direction="below"
                                    no-children-text="No sub categories for this category."
                                    :limit="3"
                                    :limitText="productCategoriesLimitText"></treeselect>
                        <div v-if="errors.product_categories"
                             class="invalid-feedback">
                            {{ errors.product_categories }}
                        </div>
                    </div>
                    <div v-if="hasMobilePhonesCategorySelected" 
                        class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Brands</label>
                        <treeselect :class="{'is-invalid': errors.brands }"
                                    v-model="form.brands"
                                    :options="brands"
                                    :normalizer="normalizer"
                                    :limit="3"
                                    :flat="true"
                                    placeholder="Select brands..."
                                    :multiple="true"
                                    open-direction="below"></treeselect>
                        <div v-if="errors.brands"
                             class="invalid-feedback">
                            {{ errors.brands }}
                        </div>
                    </div>
                    <div v-if="hasMobilePhonesCategorySelected" 
                        class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Grades</label>
                        <treeselect :class="{'is-invalid': errors.grades }"
                                    v-model="form.grades"
                                    :options="grades"
                                    :limit="3"
                                    :normalizer="normalizer"
                                    :flat="true"
                                    placeholder="Select grades..."
                                    :multiple="true"
                                    open-direction="below"></treeselect>
                        <div v-if="errors.grades"
                             class="invalid-feedback">
                            {{ errors.grades }}
                        </div>
                    </div>
                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Tax Scheme*</label>
                        <treeselect :class="{'is-invalid': errors.tax_scheme }"
                                    v-model="form.tax_scheme"
                                    :options="taxSchemes"
                                    :normalizer="normalizer"
                                    :flat="true"
                                    placeholder="Select tax scheme..."
                                    open-direction="below"></treeselect>
                        <div v-if="errors.tax_scheme"
                             class="invalid-feedback">
                            {{ errors.tax_scheme }}
                        </div>
                    </div>

                    <div class="form-group form-material floating"
                         data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Are you looking to:*</label>
                        <treeselect :class="{'is-invalid': errors['buyer'] || errors['seller'] }"
                                    :value="selectedTypes" 
                                    @input="typeChange"
                                    :multiple="true" 
                                    :options="types"
                                    placeholder="Are interested in buying and/or selling?"
                                    open-direction="below"></treeselect>
                        <div v-if="errors['buyer'] || errors['seller']"
                             class="invalid-feedback">
                            {{ errors['buyer'] || errors['seller'] }}
                        </div>
                    </div>

                    <div class="form-group form-material floating" 
                        data-plugin="formMaterial">
                        <label class="floating-label floating-label-static">Additional Info</label>
                        <textarea class="form-control" :class="{'is-invalid': errors.note}"
                            v-model="form.note" placeholder="Any other information you would like to provide...">
                        </textarea>
                        <div v-if="errors.note" class="invalid-feedback">
                            {{ errors.note }}
                        </div>
                    </div>
                    <div class="form-group form-material checkbox-custom checkbox-default"
                         data-plugin="formMaterial">
                        <input :class="{'is-invalid': errors.terms_accepted }"
                               v-model="form.terms_accepted"
                               type="checkbox"
                               id="terms_accepted"
                               name="terms_accepted"
                               checked=""
                               autocomplete="off">
                        <label class="control-label-static">
                          By signing up to our mailing list, you agree to our 
                            <a target="_blank"
                               href="http://www.ecdltd.com/terms-and-conditions">Terms &amp; Conditions</a>
                                and have read our <a target="_blank" href="http://www.ecdltd.com/privacy-policy">Privacy Policy</a>*
                        </label>
                        <div v-if="errors.terms_accepted"
                             class="invalid-feedback">
                            {{ errors.terms_accepted }}
                        </div>
                    </div>
                    <div class="form-group form-material checkbox-custom checkbox-default"
                         data-plugin="formMaterial">
                        <input v-model="form.opt_in"
                               type="checkbox"
                               id="opt_in"
                               name="opt_in"
                               checked=""
                               autocomplete="off">
                        <label class="control-label-static">
                            Yes, please keep me updated with news, events and other offers.
                        </label>
                        <div v-if="errors.opt_in"
                             class="invalid-feedback">
                            {{ errors.opt_in }}
                        </div>
                    </div>

                    <button @click="submit"
                            type="button"
                            :disabled="submitted"
                            class="btn btn-warning btn-block btn-lg mt-20 subscribe">{{ submitted ? 'Processing...' : 'Subscribe' }}
                    </button>
                 </div>
             </div>
        </div>
        <div class="loader"
             v-if="submitted"></div>
        <div role="alert"
             v-if="submittedSuccess"
             class="alert alert-success alert-dismissible">
            <button aria-label="Close"
                    data-dismiss="alert"
                    class="close"
                    type="button">
            </button>
            <h4 style="text-align:left">Success!</h4>
            <p> Your subscription request submitted successfully.
            </p>
        </div>
        <footer class="page-copyright page-copyright-inverse">
            <p>&copy; Euro Communications Distribution Ltd {{ new Date().getFullYear() }}. All rights reserved.</p>
            <div class="social">
                <a class="btn btn-icon btn-pure"
                   target="_blank"
                   href="https://twitter.com/ecdltd">
                    <i class="icon fa fa-twitter" aria-hidden="true"></i>
                </a>
                <a class="btn btn-icon btn-pure"
                   href="https://en-gb.facebook.com/ECDRepairs/"
                   target="_blank">
                    <i class="icon fa fa-facebook-f" aria-hidden="true"></i>
                </a>
                <a class="btn btn-icon btn-pure"
                   href="#">
                    <i class="icon fa fa-google-plus" aria-hidden="true"></i>
                </a>
                <a class="btn btn-icon btn-pure"
                   target="_blank"
                   href="https://www.linkedin.com/company/euro-communications-distribution-ltd">
                    <i class="icon fa fa-linkedin-square" aria-hidden="true"></i>
                </a>
            </div>
        </footer>
    </div>
</div>

</template>

<script>
export default {
    props: [
        'productCategories',
        'productConditions',
        'grades',
        'countries',
        'brands',
        'taxSchemes',
        'turnovers',
        'jobTitles',
        'sectors',
        'referrer',
    ],
    data() {
        return {
            form: new Form(
                {
                    email: '',
                    first_name: '',
                    last_name: '',
                    job_title: null,
                    mobile_number: '',
                    company_name: '',
                    website: '',
                    whatsapp_me: false,
                    whatsapp: '',
                    skype: '',
                    wechat: '',
                    viber: '',
                    linkedin: '',
                    other_name: '',
                    other_details: '',
                    product_categories: [],
                    country: null,
                    terms_accepted: false,
                    opt_in: true,
                    note: '',
                    vat_number: '',
                    company_registration_number: '',
                    office_number: '',
                    tax_scheme: null,
                    turnover: null,
                    sector: null,
                    grades: [],
                    brands: [],
                    address: {
                        building_name: '',
                        building_number: '',
                        street: '',
                        postcode: '',
                        city: '',
                        state: '',
                        country: null,
                    },
                    buyer: false,
                    seller: false,
                }),

            errors: {
                first_name: '',
                last_name: '',
                job_title: '',
                company_name: '',
                website: '',
                email: '',
                mobile_number: '',
                whatsapp_me: '',
                skype: '',
                wechat: '',
                viber: '',
                linkedin: '',
                other_name: '',
                other_details: '',
                country: '',
                product_categories: '',
                terms_accepted: '',
                note: '',
                vat_number: '',
                company_registration_number: '',
                office_number: '',
                tax_scheme: '',
                turnover: '',
                sector: '',
                grades: '',
                brands: '',
                address: {
                    building_number: '',
                    street: '',
                    postcode: '',
                    city: '',
                    state: '',
                    country: '',
                },
                buyer: '',
                seller: '',
            },
            submitted: false,
            submittedSuccess: false,
            displayForm: true,
            normalizer: function (node) {
                return {
                    id: node.id,
                    label: node.name ? node.name : node.value
                }
            },
            productCategoriesLimitText: function (count) {
                return 'Only 3 selections allowed';
            },

            types: [
                { id: 'buyer', label: 'Buy from us' },
                { id: 'seller', label: 'Sell to us' }
            ],
        }
    },
    methods: {

        submit() {
            this.submitted = true;
            this.create();
        },

        create() {

            var self = this
            setTimeout(function() {

                axios.post('/crm/contact/request', {
                    email: self.form.email,
                    first_name: self.form.first_name,
                    last_name: self.form.last_name,
                    job_title: self.form.job_title,
                    company_name: self.form.company_name,
                    website: self.form.website,
                    mobile_number: self.form.mobile_number,
                    whatsapp_me: self.form.whatsapp_me,
                    whatsapp: self.form.whatsapp,
                    wechat: self.form.wechat,
                    skype: self.form.skype,
                    viber: self.form.viber,
                    linkedin: self.form.linkedin,
                    other_name: self.form.other_name,
                    other_details: self.form.other_details,
                    country: self.form.country,
                    product_categories: self.form.product_categories,
                    terms_accepted: self.form.terms_accepted,
                    opt_in: self.form.opt_in,
                    note: self.form.note,
                    vat_number: self.form.vat_number,
                    company_registration_number: self.form.company_registration_number,
                    office_number: self.form.office_number,
                    brands: self.form.brands,
                    grades: self.form.grades,
                    tax_scheme: self.form.tax_scheme,
                    turnover: self.form.turnover,
                    sector: self.form.sector,
                    address: self.form.address,
                    buyer: self.form.buyer,
                    seller: self.form.seller,
                    referrer: self.referrer,
                }).then(function(response) {
                    self.resetForm();

                }).catch(function(error) {

                    var errors = []
                    self.errors = error.response.data.errors
                    _.forEach(error.response.data.errors, function(error, key) {
                        errors[key] = error[0]
                    })
                    self.errors = errors
                    self.submitted = false
                    self.submittedSuccess = false

                })

            }, 2000)

        },

        resetForm: function() {

            this.form.reset();

            this.submitted = false
            this.displayForm = false
            this.submittedSuccess = true

        },

        replaceObjProperties: function(resultset) {

            let self = this
            let results = []

            if (!resultset.length) {
                return []
            }

            _.forEach(resultset, function(obj) {
                results.push(self.replaceObjProperty(obj))
            })

            return results
        },

        typeChange(value) {
            this.form.buyer = value.includes('buyer');
            this.form.seller = value.includes('seller');
        },

    },

    computed: {

        productCategoriesForSelect() {
            return this.replaceObjProperties(this.productCategories)
        },

        productGradesForSelect: function() {
            return this.replaceObjProperties(this.grades)
        },

        productConditionsForSelect: function() {
            return this.replaceObjProperties(this.productConditions)
        },

        hasMobilePhonesCategorySelected: function () {
            // mobile devices id is one...
            return this.form.product_categories.includes(1);
        },

        selectedTypes() {
            let buyerSeller = [];
            if (this.form.buyer) {
                buyerSeller.push('buyer');
            }

            if (this.form.seller) {
                buyerSeller.push('seller');
            }

            return buyerSeller;
        },
    },

    watch: {
        'form.whatsapp_me'(value) {
            if (value === true && this.form.mobile_number) {
                this.form.whatsapp = this.form.mobile_number;
            } else {
                this.form.whatsapp = '';
            }
        }
    }

};

</script>

<style>
.form-text {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 10px;
}

.tblContactRequest tbody th {
    text-align: right;
    width: 200px;
    vertical-align: middle;
}

.tblContactRequest thead tr {
    background-color: #e4e4e4;
}

.form-check-input {
    margin-top: 0rem;
}

.navbar {
    min-height: 5.715rem;
}

.site-navbar .navbar-header .navbar-brand-logo {
    margin-top: -18px;
    height: 60px;
}

.site-navbar .navbar-header {
    width: 350px;
}

.panel-primary .panel-heading {
    background-color: #11589A;
}

.invalid-feedback {
    display: block;
    text-align: left!important;
}

.page-register-v3:before {
    position: fixed;
    top: 0;
    left: 0;
    content: "";
    width: 100%;
    height: 100%;
    background-position: center top;
    -webkit-background-size: cover;
    background-size: cover;
    z-index: -1;
    background: #1b369f;
}

.page-register-v3 .panel {
    width: 400px;
    margin-bottom: 45px;
    background: #fff;
    border-radius: .286rem
}

.page-register-v3 .panel .panel-body {
    padding: 50px 40px 40px
}

.page-register-v3 .panel .brand-text {
    margin-top: 8px
}

.page-register-v3 form {
    margin: 45px 0 30px
}

.page-register-v3 form a {
    margin-left: 20px
}

.page-register-v3 form .form-material.floating+.page-register-v3 form .form-material.floating {
    margin-top: 30px
}

.page-register-v3 form .form-material label {
    color: #a3afb7;
    font-weight: 300
}

@media (max-width:479px) {
    .page-register-v3 .page-content {
        padding: 30px 20px
    }
    .page-register-v3 .panel {
        width: auto;
        padding: 10px
    }
    .page-register-v3 .panel .panel-body {
        padding: 35px 25px 35px
    }
}

.text-center {
    text-align: center!important;
}

.layout-full .page {
    height: 100%;
    margin: 0!important;
    padding: 0;
    background-color: transparent;
}

.btn-primary {
    color: #fff;
    background-color: #3e8ef7;
    border-color: #3e8ef7;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.form-material.floating {
    margin-top: 20px;
    margin-bottom: 20px;
}

.form-material .floating-label.floating-label-static {
    position: relative;
    top: auto;
    display: block;
    text-align: left;
}

.panel {
    width: 550px!important;
}

.floating-label {
    font-size: 14px!important;
}

.checkbox-custom {
    text-align: left;
}

.page-register-v3 form a {
    margin-left: 0px;
}

.form-control {
    height: 3.40rem;
}

.loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* Add animation to "page content" */

.animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
}

@-webkit-keyframes animatebottom {
    from {
        bottom: -100px;
        opacity: 0
    }
    to {
        bottom: 0px;
        opacity: 1
    }
}

@keyframes animatebottom {
    from {
        bottom: -100px;
        opacity: 0
    }
    to {
        bottom: 0;
        opacity: 1
    }
}

.btn-warning {
    background-color: #FC891C;
    border-color: #FC891C;
}

.btn-warning:hover {
    background-color: #FC891C;
    border-color: #FC891C;
}

.panel-bordered {
    border-bottom: 10px solid #1c379f;
}

.panel-bordered>.panel-body {
    border: 0;
}

.inline-input {
    width: 200px !important;
}

.form-inline {
    justify-content: space-between;
}

.floating-label-static {
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/external/components/crm/contacts/request/create.vue